import { DataLockedAndLoadedCard, ICON_SIZES } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Theme, SxProps } from '@mui/material';

import { OnboardingFlow } from './onboarding.types';
import { OnboardingSidebarItems } from './OnboardingSidebarItems';

const BACKRS_MARKETING_SITE = process.env.BACKRS_MARKETING_SITE || 'https://www.backrs.com';
const DATA_LOCKED_STRINGS = appStrings.modules.onboarding.dataLockedCards;

const FIGMA_WIDTH = 1440;

type OnboardingSidebarProps = Readonly<{
  currentQuestionIndex: number;
  currentFlow: OnboardingFlow | 'START';
  sidebarCard?: 'data-locked' | 'team-will-contact';
}>;

export const OnboardingSidebar = ({
  currentQuestionIndex,
  currentFlow,
  sidebarCard,
}: OnboardingSidebarProps) => {
  const dataLockedConfig = {
    'data-locked': {
      imageUrl: '/images/data-hexagon.svg',
      backrsPage: 'data-pledge',
      ...DATA_LOCKED_STRINGS['data-locked'],
    },
    'team-will-contact': {
      imageUrl: '/images/easy-green-paper-airplane.svg',
      backrsPage: 'privacy-policy',
      ...DATA_LOCKED_STRINGS['team-will-contact'],
    },
  };

  return (
    <Box sx={sideBarStyle}>
      <Box sx={logoContainerSx}>
        <Box
          component="img"
          src="../images/backrs-drop-shadow-logo-text.svg"
          alt="Backrs Logo"
          sx={backrsLogoImageSx}
        />
      </Box>
      <OnboardingSidebarItems flow={currentFlow} selectedIndex={currentQuestionIndex} />

      {sidebarCard && (
        <Box sx={dataLockedContainerSx}>
          <DataLockedAndLoadedCard
            title={dataLockedConfig[sidebarCard].title}
            description={dataLockedConfig[sidebarCard].description}
            imageUrl={dataLockedConfig[sidebarCard].imageUrl}
            learnMore={{
              text: dataLockedConfig[sidebarCard].learnMore,
              onClick: () =>
                window.open(
                  `${BACKRS_MARKETING_SITE}/${dataLockedConfig[sidebarCard].backrsPage}`,
                  '_blank',
                ),
            }}
          />
        </Box>
      )}
    </Box>
  );
};

const sideBarStyle: SxProps<Theme> = ({ backrs }) => ({
  width: {
    xs: `60vw`,
    sm: '40vw',
    md: '50vw',
    lg: `calc(${440 / FIGMA_WIDTH} * 100%)`,
  },
  maxWidth: 440,
  height: '100dvh',
  padding: backrs.spacing['spacing-4xl'],

  display: { xs: 'none', sm: 'flex' },
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',

  backgroundColor: backrs.colors['Beige/50'],
  borderRight: `1px solid ${backrs.colors['Colors/Base/Black']}`,
});

const logoContainerSx: SxProps<Theme> = ({ backrs }) => ({
  gap: backrs.spacing['spacing-md'],
  display: 'flex',
  marginBottom: backrs.spacing['spacing-2xl'],
  minHeight: ICON_SIZES['32px'],
  alignItems: 'center',
});

const backrsLogoImageSx: SxProps<Theme> = () => ({
  height: ICON_SIZES['32px'],
});

const dataLockedContainerSx: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  alignItems: 'flex-end',
  width: '100%',
};
